<template>
  <div>
    <out-reach-top-links-clicked
      :top-links="topLinks"
      :loading="loading"
      @view-all="viewAll"
      @view-detail="onViewDetail"
    />
    <client-click-events-modal-container
      v-if="showModal"
      :url="modalUrl"
      :count="modalCount"
      :outreach-id="outreachId"
      @closed="onClosed"
    />
  </div>
</template>
<script>
import ClientClickEventsModalContainer from '@/components/Widgets/ClientHistory/ClientClickEventsModalContainer';
import OutReachTopLinksClicked from '@/components/Widgets/OutReachs/OutReachTopLinksClicked';

export default {
  name: 'OutReachTopLinksClickedContainer',
  components: {
    ClientClickEventsModalContainer,
    OutReachTopLinksClicked,
  },
  data() {
    return {
      showModal: false,
      modalCount: null,
      modalUrl: null,
    };
  },
  computed: {
    stats() {
      return this.$store.state.outreachs.stats;
    },
    outreachId() {
      return this.$route.params.id;
    },
    topLinks() {
      return this.stats.top_links;
    },
    loading() {
      return this.$store.state.outreachs.statsLoading;
    },
  },
  methods: {
    viewAll() {
      this.$router.push(`/events/${this.outreachId}/click`);
    },
    onViewDetail({ url, count }) {
      // Show link clicks detail
      // Retrieve events
      this.modalUrl = url;
      this.modalCount = count;
      this.showModal = true;
    },
    onClosed() {
      this.showModal = false;
      this.modalUrl = null;
      this.modalCount = null;
    },
  },
};
</script>
